import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { ReactiveFormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { MatSelectModule } from '@angular/material/select'
import { TranslateModule } from '@ngx-translate/core'

import { DateFieldModule } from '../date-selector'
import { ResourceSelectorModule } from '../resource-selector'
import { SearchableSelectModule } from '../searchable-select'
import { PriorAuthorizationFormComponent } from './components'

@NgModule({
  declarations: [
    PriorAuthorizationFormComponent,
  ],
  imports: [
    CommonModule,
    DateFieldModule,
    FlexLayoutModule,
    MatButtonModule,
    MatExpansionModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    ReactiveFormsModule,
    ResourceSelectorModule,
    SearchableSelectModule,
    TranslateModule,
  ],
  exports: [
    PriorAuthorizationFormComponent,
  ],
})
export class PriorAuthorizationFormModule {}
